import { render, staticRenderFns } from "./CardImg.vue?vue&type=template&id=b0a06f3c&"
import script from "./CardImg.vue?vue&type=script&lang=js&"
export * from "./CardImg.vue?vue&type=script&lang=js&"
import style0 from "./CardImg.vue?vue&type=style&index=0&id=b0a06f3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports